import React from "react";
import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 rounded-md text-[14px] font-medium transition-colors duration-300 select-none";

const variants = {
  primary:
    "bg-brand-orange text-white hover:bg-[#e35c3a] px-5 py-3 shadow-[0_0_0_1px_rgba(255,255,255,0.02),0_20px_50px_-20px_rgba(209,79,42,0.55)]",
  secondary:
    "bg-white/[0.04] border border-white/10 text-white hover:bg-white/[0.08] backdrop-blur px-5 py-3",
  ghost:
    "text-white/80 hover:text-white px-3 py-2",
};

export default function Button({
  to,
  href,
  onClick,
  children,
  variant = "primary",
  className = "",
  arrow = true,
  testId,
  type = "button",
}) {
  const content = (
    <>
      {children}
      {arrow && (
        <span
          aria-hidden
          className="inline-block transition-transform duration-300 group-hover:translate-x-0.5"
        >
          →
        </span>
      )}
    </>
  );
  const cls = `group ${base} ${variants[variant]} ${className}`;

  if (to)
    return (
      <Link to={to} className={cls} data-testid={testId}>
        {content}
      </Link>
    );
  if (href)
    return (
      <a href={href} className={cls} data-testid={testId} target="_blank" rel="noreferrer">
        {content}
      </a>
    );
  return (
    <button
      type={type}
      onClick={onClick}
      className={cls}
      data-testid={testId}
    >
      {content}
    </button>
  );
}
